import { Observable, throwError } from 'rxjs';
import * as moment from 'moment';


/**
 * Parse Date string from any format like DD-MM-YYYY OR DD/MM/YYYY OR YYYY-MM-DD
 * @param value: string
 * @returns string // Date value in YYYY-MM-DD format
 */
export function parseDate(value: string): string {
  let format = "";

  // If value is in YYYY-MM-DD format then change format to this
  if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(value)) {
    format = "YYYY-MM-DD";
  }

  // If value is in DD-MM-YYYY format then change format to this
  if (/((0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-[12]\d{3})/.test(value)) {
    format = "DD-MM-YYYY";
  }

  // If value is in DD/MM/YYYY format then change format to this
  if (/((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/[12]\d{3})/.test(value)) {
    format = "DD/MM/YYYY";
  }

  if (format)
    return moment(value, format).format('YYYY-MM-DD');
  else
    return moment(value).format('YYYY-MM-DD');
}


/**
 * Get 2 characters acronym from a string of multple words
 * @param term: String
 * @returns acronym term
 */
export function getAcronym(term: string) {
  if (term) {
    return term
      .split(/\s/)
      .slice(0, 2)
      .reduce(function (accumulator, word) {
        return accumulator + word.charAt(0);
      }, '');
  }

  return term;
}

/**
 * Creqte URL query string from the object properties. e.g. {a:10 & b:20} = a=10&b=20.
 * @param error: Object
 * @returns Error
 */
export function queryString(paramsObject: any): string {
  return Object
    .keys(paramsObject)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
    .join('&');
}


/**
 * Error Handler Method to extract error message from the server error object
 * @param error: Object
 * @returns Error
 */
export function errorHandler(error) {
  let errorMessage = '';
  if (error.error instanceof ErrorEvent) {
    // Get client-side error
    errorMessage = error.error.message;
  } else {
    // Get server-side error
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  }
  return throwError(errorMessage);
}


/**
 * Generate Unique Number
 * @returns number
 */
export function uniqueId() {
  return Date.now() + Math.floor(Math.random() * 999999);;
}


/**
 * Sort object properties by another array of keys
 * @param object: Object
 * @param sortedKeys: Array<object>
 * @returns object
 */
export function sortObjectKeys(object, sortedKeys) {
  let sortedObjKeys = Object.keys(object).sort((a: string, b: string) => {
    return sortedKeys.indexOf(a) > sortedKeys.indexOf(b) ? 1 : -1;
  });

  let sortedObject = {};
  for (let objKey of sortedObjKeys) {
    sortedObject[objKey] = object[objKey]
  }

  return sortedObject
}

/**
 * Check Mobile view
 *
 */
export function checkMobileView() {

  if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)) {
    return true;
  }

  return (window as any).innerWidth < 768;
}


/**
 * Takes a {} object and returns a FormData object
 */
export function objectToFormData(obj: any, form: FormData = null, namespace = ''): FormData {

  let formData = form || new FormData();
  let formKey;

  for (let propertyName in obj) {

    if (obj.hasOwnProperty(propertyName) || obj[propertyName]) {
      let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

      if (obj[propertyName] instanceof Array) {
        if (obj[propertyName].length) {
          obj[propertyName].forEach((element, index) => {
            const tempFormKey = `${formKey}[${index}]`;

            if (element instanceof File) {
              formData.append(tempFormKey, element);
            } else if (element && typeof element === 'object') {
              objectToFormData(element, formData, tempFormKey);
            } else {
              formData.append(tempFormKey, element == null || element === undefined ? '' : element);
            }
          });
        } else {
          formData.append(formKey, obj[propertyName]);
        }

      }
      else if (obj[propertyName] instanceof File) {
        formData.append(formKey, obj[propertyName]);
      }
      else if (obj[propertyName] && typeof obj[propertyName] === 'object') {
        objectToFormData(obj[propertyName], formData, formKey);
      }
      else {
        formData.append(formKey, obj[propertyName] == null || obj[propertyName] === undefined ? '' : obj[propertyName]);
      }
    }
  }

  return formData;
}


export function extractObjectValue(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}

export function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

// returns a string on success, null in failure
export function fileNameFromUrl(url) {
  let matches = url.match(/\/([^\/?#]+)[^\/]*$/);
  if (matches.length > 1) {
    return matches[1];
  }
  return null;
}

/**
 * To copy any Text
 * @param val This is the string to copy
 */
export function copyText(val: string) {
  let selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
}
